import useMatchMedia from './useMatchMedia';

/**
 * 모바일 레이아웃 여부를 반환하는 훅.
 * tailwind 의 `md:1280px` 브레이크포인트와 경계를 맞추기 위해 `max-width: 1279px` 를 사용한다.
 * 태블릿 밴드(800~1279px)도 모바일 레이아웃이 담당한다 — 데스크톱 설계폭(1199~1280px 고정)
 * 미만을 데스크톱으로 억지로 버티게 하지 않는다.
 * JSX 구조 자체가 달라지는 경우에만 사용하고, 순수 레이아웃 변화는 CSS media 로 처리한다.
 * 레이아웃 모드와 무관한 분기(헤더 GNB 폭 등)는 useMatchMedia 로 별도 쿼리를 쓸 것.
 */
const MOBILE_QUERY = '(max-width: 1279px)';

const useIsMobile = (): boolean => useMatchMedia(MOBILE_QUERY);

export default useIsMobile;
